import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Autocomplete } from '@emburse/ui-core';
import { useAllowedVendorsQuery } from './allowedVendorsQueries';
export const VendorRestrictionsField = ({ defaultValue, onChange }) => {
    const [value, setValue] = React.useState(null);
    const allowedVendors = useAllowedVendorsQuery();
    const options = (allowedVendors.data || [])
        .map((vendor) => ({
        label: vendor.name,
        value: vendor.id
    }))
        .sort((a, b) => a.label.localeCompare(b.label));
    React.useEffect(() => {
        if (allowedVendors.isSuccess && options.length > 0) {
            setValue(options.find((option) => defaultValue === option.value) || null);
        }
    }, [allowedVendors.isSuccess]);
    return (_jsx(Autocomplete, { label: 'Allowed Vendors', value: value, options: options, getOptionLabel: (option) => option.label, onChange: (_, newValue) => {
            setValue(newValue);
            onChange((newValue === null || newValue === void 0 ? void 0 : newValue.value) || '');
        } }));
};
